import { Box, Flex, Image } from "@chakra-ui/react";
import PropTypes from "prop-types";
import bannerCard from "assets/img/auth/banner-card.png";

function AuthIllustration(props: { children: JSX.Element | string }) {
  const { children } = props;

  return (
    <Flex
      height="100vh"
      width="100vw"
      // overflow="hidden"
    >
      {/* Left side - Login form */}
      <Flex
        width={{ base: "100%", lg: "50%" }}
        flexDirection="column"
        bg="white"
        overflowY="auto"
      >
        <Flex
          h="100%"
          w="100%"
          mx="auto"
          justifyContent="center"
          alignItems={{ base: "center", xl: "flex-end" }}
          direction="column"
          pr={{ base: "0px", xl: "120px" }}
        >
          <Box w="100%" maxW={{ base: "100%", lg: "453px" }}>
            {children}
          </Box>
        </Flex>
      </Flex>

      {/* Right side - Gradient background with banner */}
      <Flex
        width={{ base: "100%", lg: "50%" }}
        background="linear-gradient(135deg, #F7F7F9 0%, #EBF0FB 100%)"
        display={{ base: "none", lg: "flex" }}
        alignItems="center"
        justifyContent={{ base: "center", xl: "flex-start" }}
        pl={{ base: "0px", xl: "95px" }}
      >
        <Image
          src={bannerCard}
          alt="Banner"
          w="452px"
          objectFit="contain"
        />
      </Flex>
    </Flex>
  );
}

AuthIllustration.propTypes = {
  illustrationBackground: PropTypes.string,
  image: PropTypes.any,
};

export default AuthIllustration;
